import { render, staticRenderFns } from "./guanyuwomen.vue?vue&type=template&id=4a7da67e&scoped=true"
import script from "./guanyuwomen.vue?vue&type=script&lang=js"
export * from "./guanyuwomen.vue?vue&type=script&lang=js"
import style0 from "./guanyuwomen.vue?vue&type=style&index=0&id=4a7da67e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7da67e",
  null
  
)

export default component.exports